export default __webpack_public_path__ + "static/media/uhlaeh.dfad07ee.png";